export const USA_TZ = 'America/New_York'

/**
 * @param {string | null | undefined} displayName
 * @param {Date} [now]
 */
export function getUsaGreeting(displayName, now = new Date()) {
  const hour = Number(
    new Intl.DateTimeFormat('en-US', { timeZone: USA_TZ, hour: 'numeric', hour12: false }).format(now)
  )
  const period = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : 'evening'
  const name = displayName?.trim() || 'there'
  return { text: `Good ${period}, ${name}`, period, timezone: USA_TZ }
}

/**
 * @param {Date} [now]
 */
export function formatUsaDateTime(now = new Date()) {
  const datePart = new Intl.DateTimeFormat('en-US', {
    timeZone: USA_TZ,
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(now)
  const timePart = new Intl.DateTimeFormat('en-US', {
    timeZone: USA_TZ,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(now)
  return `${datePart} · ${timePart} ET`
}
